import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LanguageIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 2c0-.6.4-1 1-1h1a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Zm6 2H2a1 1 0 0 0 0 2h8.1l-.9 1.4L7.5 9 5.7 7.3a1 1 0 0 0-1.4 1.4L6 10.5l-2.8 2.8a1 1 0 1 0 1.4 1.4L7.5 12l2.8 2.8a1 1 0 0 0 1.4-1.4L9 10.5l1.8-1.8.1-.1L12.5 6H14a1 1 0 1 0 0-2h-2Zm5 7c.4 0 .7.2.9.6l3 6 2 4a1 1 0 1 1-1.8.8L19.4 19h-4.8L13 22.4a1 1 0 1 1-1.8-.8l2-4 3-6c.2-.4.5-.6.9-.6Zm-1.4 6h2.8L17 14.2 15.6 17Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default LanguageIcon;
